import { getFirebaseAnalytics } from '../../hooks/useFirebaseAnalytics';
import { ANALYTICS_EVENTS } from './AnalyticsConstants';

export const trackSeedingPrescriptionCreated = (jobId, usedCalculator, prescriptionModel) => {
  const { eventname, eventparams } = ANALYTICS_EVENTS.seedingPrescriptionCreated(
    jobId,
    usedCalculator,
    prescriptionModel
  );

  try {
    getFirebaseAnalytics()?.logEvent(eventname, eventparams);
  } catch (error) {
    // Analytics must not turn a successful save into a failed save.
  }
};
